//account expired plans constants

export const GET_EXPIRED_PLANS_ATTEMPT = "GET_EXPIRED_PLANS_ATTEMPT";
export const GET_EXPIRED_PLANS_SUCCESS = "GET_EXPIRED_PLANS_SUCCESS";
export const GET_EXPIRED_PLANS_FAILURE = "GET_EXPIRED_PLANS_FAILURE";
export const CLEAR_EXPIRED_PLANS_STATE = "CLEAR_EXPIRED_PLANS_STATE";

export const CLEAR_STATE = "CLEAR_STATE";
